var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashButtonMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "10 12 24 24",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5257 34.2772H18.6685C18.6685 34.2772 17.6309 34.3465 17.6309 33.1601L16.7932 20.3929H30.4381C30.4381 20.3929 29.8398 30.4871 29.6803 31.8436",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.616 23.8V30.766",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2207 23.9994L20.6196 30.766",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0109 23.9994L26.6121 30.766",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6758 20.3927C17.6758 20.3927 15.9984 20.6321 16 19.9404C16.0024 19.008 17.1705 16.6336 18.3141 16.6336H28.9006H28.9169C30.0609 16.6336 31.2286 19.008 31.231 19.9404C31.2331 20.5158 29.5556 20.3927 29.5556 20.3927",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8139 16.0947V15.7044C25.8139 14.9666 25.4631 14.3679 25.0304 14.3679H22.2012C21.7685 14.3679 21.4177 14.9666 21.4177 15.7044V16.0947",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashButtonMono);
export default __webpack_public_path__ + "static/media/trash-button-mono.8a71f7167432963491edd1734a9e8ab1.svg";
export { ForwardRef as ReactComponent };